"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$grey;

  return {
    root: {
      "& > a": {
        pointerEvents: "none"
      }
    },
    content: {
      border: "1px solid " + ((_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$grey = _theme$palette.grey) === null || _theme$palette$grey === void 0 ? void 0 : _theme$palette$grey[300]),
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(3)
    },
    imageRoot: {
      position: "relative",
      pointerEvents: "all",
      "& img, & picture": {
        height: "100%",
        width: "100%"
      }
    },
    imageRootRight: _defineProperty({}, theme.breakpoints.up("sm"), {
      order: 2
    }),
    addition: {
      color: theme.palette.text.primary,
      marginBottom: theme.spacing(1)
    },
    title: {
      color: theme.palette.text.primary,
      marginBottom: theme.spacing(1),
      pointerEvents: "all"
    },
    text: {
      color: theme.palette.text.primary
    },
    chip: {
      display: "none",
      position: "absolute",
      right: theme.spacing(2),
      top: theme.spacing(2)
    },
    button: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "auto",
      paddingTop: theme.spacing(2),
      pointerEvents: "all"
    }
  };
});
var _default = styles;
exports.default = _default;